$(document).ready(function () {
  // --------------------- LIVE SEARCH & HEADER SCROLL ---------------------
  $(".site-header-search-bar").click(function () {
    $(this).next(".live-search").toggleClass("displayimp");
  });

  window.addEventListener("scroll", function () {
    var width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    var siteLogo = document.querySelector(".site-logo");
    var scrollSiteLogo = document.querySelector(".scroll-site-logo");
    var siteHeader = document.querySelector(".site-header");

    if (width > 768) {
      if (window.scrollY > 0) {
        scrollSiteLogo.style.display = "block";
        siteLogo.style.display = "none";
        siteHeader.style.backgroundColor = "#FFFFFF";
      } else {
        scrollSiteLogo.style.display = "none";
        siteLogo.style.transition = "1s";
        siteLogo.style.display = "block";
        if (width > 1024) {
          siteHeader.style.backgroundColor = "#ffffff63";
        }
      }
    }
  });

  // Remove unwanted classes from mobile nav panels.
  $(".mobile-nav-panel ul").removeClass("divgrds");

  // --------------------- GROUP TABS & BUILD SIDEBAR ---------------------
  // Expecting structure:
  // <div class="custom--tabs">
  //   <div class="tab_tablinks">
  //     ... rendered tab links with class "custom_tablinks" ...
  //   </div>
  //   ... tab content blocks with IDs matching data-city ...
  //   <h2 class="title_4c"></h2> (optional title element)
  // </div>
  var $customTabsContainer = $(".custom--tabs");
  if ($customTabsContainer.length) {
    var $tabLinksContainer = $customTabsContainer.find(".tab_tablinks");
    if ($tabLinksContainer.length) {
      // Get all the rendered tab links.
      var $allTabs = $tabLinksContainer.find(".custom_tablinks");
      if ($allTabs.length) {
        // Separate "location" tabs (identified by having a data-country attr
        // or by containing .location_details_tab_link) from the rest.
        var $locationTabs = $();
        var $otherTabs = $();
        $allTabs.each(function () {
          var $tab = $(this);
          if ($tab.data("country") || $tab.find(".location_details_tab_link").length > 0) {
            $locationTabs = $locationTabs.add($tab);
          } else {
            $otherTabs = $otherTabs.add($tab);
          }
        });

        // Group the location tabs by country.
        var groups = {};
        $locationTabs.each(function () {
          var $tab = $(this);
          var country = $tab.data("country");
          if (!country) {
            // Extract country from the first <b> element inside .location_details_tab_link
            country = $tab.find(".location_details_tab_link p:first-child b").text().trim();
          }
          if (!groups[country]) {
            groups[country] = $();
          }
          groups[country] = groups[country].add($tab);
        });

        // Clear the original container so we can rebuild it.
        $tabLinksContainer.empty();

        // Build groups: For each country, add a header to toggle and a container for city links.
        $.each(groups, function (country, $tabsGroup) {
          var $groupContainer = $("<div>", { class: "country-group" });
          // Header contains the country name and an SVG chevron.
          var svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>';
var formattedCountry = country
  .split("-")
  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
  .join(" ");
var $header = $("<div>", { class: "country-header" }).html("<span>" + formattedCountry + "</span>" + svgIcon);
          var $cityLinks = $("<div>", { class: "city-links" }).css("display", "none");

          // Detach each tab from the group and add it into the city links container.
          $tabsGroup.each(function () {
            var $tabClone = $(this).detach();
            // Rebind the click event so the inline onclick still works via openCity.
            $tabClone.on("click", function (evt) {
              evt.preventDefault();
              openCity(evt, $tabClone.data("city"));
            });
            $cityLinks.append($tabClone);
          });

          // Header toggles the city-links group.
          $header.on("click", function () {
            // Close any other open groups.
            $tabLinksContainer.find(".city-links").not($cityLinks).slideUp();
            $tabLinksContainer.find(".chevron-down").not($header.find(".chevron-down")).css("transform", "rotate(0deg)");
            if ($cityLinks.is(":visible")) {
              $cityLinks.slideUp();
              $header.find(".chevron-down").css("transform", "rotate(0deg)");
            } else {
              $cityLinks.slideDown();
              $header.find(".chevron-down").css("transform", "rotate(180deg)");
            }
          });

          $groupContainer.append($header).append($cityLinks);
          $tabLinksContainer.append($groupContainer);
        });

        // Append any non-location tabs after the groups.
        if ($otherTabs.length) {
          $tabLinksContainer.append($otherTabs);
        }
      }
    }
  }

  // --------------------- TAB INITIALIZATION ---------------------
  // Mark the first available tab as active if none is yet active.
  var $firstActive = $(".custom--tabs .custom_tablinks.active");
  if (!$firstActive.length) {
    var $firstTab = $(".custom--tabs .custom_tablinks").first();
    $firstTab.addClass("active");
    var cityName = $firstTab.data("city");
    $("#" + cityName).show();
    var activeTabName = $firstTab.text();
    var $titleElement = $firstTab.closest(".tablinks-section").find(".title_4c");
    if ($titleElement.length) {
      $titleElement.text(activeTabName);
    }
  }

  // --------------------- TAB SWITCHING FUNCTION ---------------------
  // Global so that inline onclick events in Liquid markup (openCity) still work.
  window.openCity = function (evt, cityName) {
    var $tabContainer = $(evt.currentTarget).closest(".tab-container");
    if (!$tabContainer.length) return;

    // Hide all tab content blocks within this container.
    $tabContainer.find(".tabcontent").hide();
    // Remove active state from tab links in this container.
    $tabContainer.find(".custom_tablinks, .tablinks").removeClass("active");

    // Show the relevant tab content.
    var $selectedContent = $("#" + cityName);
    if ($selectedContent.length) {
      $selectedContent.show();
      // Smooth scroll to content after a short delay.
      setTimeout(function () {
        if (!$selectedContent.hasClass("no_offset")) {
          var offsetTop = $selectedContent.offset().top - 200;
          $("html, body").animate({ scrollTop: offsetTop }, 500);
        }
      }, 0);
    }
    $(evt.currentTarget).addClass("active");

    // Update the title element if present.
    var activeTabName = $(evt.currentTarget).text();
    var $titleElement = $(evt.currentTarget).closest(".tablinks-section").find(".title_4c");
    if ($titleElement.length) {
      $titleElement.text(activeTabName);
    }

    // Initialize external form builder if applicable.
    if (window.Globo && Globo.FormBuilder) {
      Globo.FormBuilder.initialize();
    }
  };

  // --------------------- URL FRAGMENT HANDLING ---------------------
  var fragment = window.location.hash.substr(1);
  if (fragment) {
    var $tab = $('.custom_tablinks[data-city="' + fragment + '"]');
    if ($tab.length) {
      $tab.click();
    }
  }

  // --------------------- VIDEO ---------------------
  $("video.cstm-vid source").each(function () {
    var sourceFile = $(this).attr("src");
    $(this).attr("src", sourceFile);
    var video = this.parentElement;
    video.load();
    video.play();
  });

  $(document).on("click", ".video-control", function () {
    var video = $("video").get(0);
    if (video.paused) {
      $("video").trigger("play");
      $(".video-control-pause").css("display", "none");
      $(".video-control-play").css("display", "block");
      $(".video-control").css("background", "none");
    } else {
      $("video").trigger("pause");
      $(".video-control-pause").css("display", "block");
      $(".video-control-play").css("display", "none");
    }
    return false;
  });

  // --------------------- REVIEW VIDEO CONTROLS ---------------------
  (function () {
    function handleVideoState(element) {
      var videoElement = $(element).find(".video-cdn")[0];
      var isSelected = $(element).hasClass("is-selected");
      var videoSource = $(videoElement).find("source").attr("src");
      if (isSelected && videoSource !== "") {
        videoElement.play();
      } else {
        videoElement.pause();
      }
    }
    $(".review-video").each(function () {
      handleVideoState(this);
    });
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          handleVideoState(mutation.target);
        }
      });
    });
    $(".review-video").each(function () {
      observer.observe(this, { attributes: true });
    });
  })();

  // --------------------- ACCORDIONS ---------------------
  // Color Of Our Accordian
  setTimeout(function () {
    $(".image_gallery_accordion").css("opacity", "1");
  }, 1);

  $(".image_gallery_accordion").each(function () {
    var section = $(this);
    section.find(".image_accordion_item:first").addClass("expand");
    section.find(".image_accordion_item_content:first").addClass("visible");
  });

  $(".image_accordion_item").on("click", function () {
    var section = $(this).closest(".image_gallery_accordion");
    var allItems = section.find(".image_accordion_item");
    var allContents = section.find(".image_accordion_item_content");
    var isSelected = $(this).hasClass("expand");
    allItems.removeClass("expand");
    allContents.removeClass("visible");
    if (!isSelected) {
      $(this).addClass("expand");
      $(this).find(".image_accordion_item_content").addClass("visible");
    }
  });

  // Image Accordion hover effect
  document.querySelectorAll(".custom_image_accordian").forEach(function (element) {
    element.addEventListener("mouseover", function () {
      element.classList.add("hovered");
    });
    element.addEventListener("mouseout", function () {
      element.classList.remove("hovered");
    });
  });

  // --------------------- PRODUCT SWAPPING GRIDS ---------------------
  var swappedElements = null;
  window.toggleImageSize = function (element, index) {
    document.querySelectorAll(".image-container").forEach(function (el) {
      el.classList.remove("active");
    });
    element.classList.add("active");
    document.querySelectorAll(".image-container:not(.active)").forEach(function (el) {
      el.classList.remove("active");
    });
    var imageGrid = document.querySelector(".image-grid");
    if (index % 2 !== 0) {
      imageGrid.classList.add("grid-auto-dense");
    } else {
      imageGrid.classList.remove("grid-auto-dense");
    }
    if (index === 3) {
      if (!swappedElements) {
        imageGrid.classList.remove("grid-auto-dense");
        var fourthDiv = document.querySelector(".image-container:nth-child(4)");
        var fifthDiv = document.querySelector(".image-container:nth-child(5)");
        var parent = fourthDiv.parentNode;
        swappedElements = { parent: parent, fourthDiv: fourthDiv, fifthDiv: fifthDiv };
        parent.insertBefore(fifthDiv, fourthDiv);
      }
    } else {
      if (swappedElements) {
        var parent = swappedElements.parent;
        parent.insertBefore(swappedElements.fourthDiv, swappedElements.fifthDiv);
        swappedElements = null;
      }
    }
  };

  // --------------------- TESTIMONIAL ---------------------
  $(".read_more").on("click", function () {
    var reviewText = $(this).closest(".client_review_text").find("p");
    reviewText.addClass("expand_needed");
    $(this).hide();
    $(this).siblings(".read_less").show();
  });
  $(".read_less").on("click", function () {
    var reviewText = $(this).closest(".client_review_text").find("p");
    reviewText.removeClass("expand_needed");
    $(this).hide();
    $(this).siblings(".read_more").show();
  });
  $(".client_review_text p").each(function () {
    if ($(this).height() > 80) {
      $(this).addClass("expand_needed");
      $(this).closest(".client_review_text").find(".read_more").show();
    }
  });

  // --------------------- FAQ ICON ROTATE ---------------------
  $(".collapsible-tab__heading").click(function () {
    var icon = $(this).find(".icon-plus");
    if (icon.length > 0) {
      icon.toggleClass("rotate_icon");
    }
  });
  $(".collapsible-tab__heading").dblclick(function () {
    var icon = $(this).find(".icon-plus");
    if (icon.length > 0) {
      icon.removeClass("rotate_icon");
    }
  });

  // --------------------- MCE-FRAGMENT REMOVAL ---------------------
  document.querySelectorAll('[data-mce-fragment="1"]').forEach(function (element) {
    element.removeAttribute("data-mce-fragment");
  });

  // --------------------- DROPDOWN TOGGLE ---------------------
  $(document).on("click", ".tab_content_dd", function () {
    $(this).find(".tab-dropdown-content").toggleClass("display");
  });
  $(document).on("click", ".category-dropdown", function () {
    $(this).find(".dropdown-content").toggleClass("display");
    $(this).find(".icon_down").toggleClass("rotate_it");
  });
  $(".category-dropdown").dblclick(function () {
    $(this).find(".icon_down").removeClass("rotate_it");
  });

  // --------------------- QUOTE FORM ---------------------
  $(document).on("click", ".request-quote", function () {
    $(".quote_form").toggleClass("display");
    $(".request-quote").css("display", "none");
  });

  // --------------------- MULTI VIDEO ---------------------
  document.addEventListener("DOMContentLoaded", function () {
    var gridItems = document.querySelectorAll(".video-grid-item");
    gridItems.forEach(function (item) {
      item.addEventListener("click", function () {
        var videoUrl = item.getAttribute("data-video-url");
        playVideo(videoUrl);
      });
    });
    function playVideo(videoPath) {
      var videoPlayer = document.getElementById("mainVideo");
      videoPlayer.src = videoPath;
      videoPlayer.load();
      videoPlayer.play();
    }
  });

  // --------------------- CSRA/ INTERNATIONAL SHOW MODAL ---------------------
  document.addEventListener("DOMContentLoaded", function () {
    var clickableElements = document.querySelectorAll(".pop-up-modal-container");
    clickableElements.forEach(function (element) {
      element.addEventListener("click", function () {
        closeAllPopups();
        var popupBox = element.nextElementSibling;
        if (popupBox) {
          popupBox.classList.toggle("displayimp");
        }
      });
    });
    function closeAllPopups() {
      var openPopups = document.querySelectorAll(".popup-box.displayimp");
      openPopups.forEach(function (popup) {
        popup.classList.remove("displayimp");
      });
    }
  });
  $(document).ready(function () {
    $(".close_btn").click(function () {
      var popupBox = $(this).closest(".popup-box");
      popupBox.removeClass("displayimp");
    });
  });

  // --------------------- SCROLLING ARROWS ---------------------
  $(".prev-options").each(function () {
    $(this).click(function () {
      var posLeft = $(this).siblings(".scroll_overflow").scrollLeft();
      $(this).siblings(".scroll_overflow").animate({ scrollLeft: posLeft - 200 }, 200);
    });
  });
  $(".next-options").each(function () {
    $(this).click(function () {
      var posLeft = $(this).siblings(".scroll_overflow").scrollLeft();
      $(this).siblings(".scroll_overflow").animate({ scrollLeft: posLeft + 200 }, 200);
    });
  });
});
